import React from "react";

import Vector1 from '../assets/img/Vector.png'
import Chat from '../assets/svg/landingChat.svg'
import Users from '../assets/svg/Users.svg'
import Groups from '../assets/svg/Groups.svg'
import VirtualVector from '../assets/svg/VirtualVector.svg'
import NEUniteLogo from '../assets/svg/Logo.svg'

import { useHomeStyles } from '../styles/muiStyles';
import { styled } from '@mui/material/styles';
import { Button, Container, Paper} from '@material-ui/core'
import { Link } from 'react-scroll'

import {
    Typography,
} from '@mui/material';

import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';






const Home =  () =>{
    const classes= useHomeStyles();
 

    return (
        <div >
            <nav className={classes.navbar}>
                <div className={classes.logoFlex}>
                    <img src={NEUniteLogo} alt="logo" className={classes.logo} />
                        <Typography variant='h6' className={classes.logoName}>
                                <strong> <i>NEUMeet</i></strong>
                        </Typography>
                </div>
                    
            </nav>
            <header className={classes.row} style={{color:'#fff',}} >
                <div style={{ padding:'15vh 0', width:'100vw' }}>
                    <div className={classes.row} >
                        <Container className={classes.column} >
                            <img src={Vector1} alt='3' className={classes.Vectors}/>
                        </Container>
                        <div className={classes.column}>
                            <Container  className= {classes.slideTextRight}>
                                <em className={classes.titleFontSize}>Make A Difference</em>
                                <p   className={classes.DescriptionFontSize}>                            
                                NEUMeet for New Normal. Engaged in a place where you can still talk and meet with your 
                                    favorite people without physically attending to them and stay connected despite the new 
                                    living.
                                </p>
                                <Button href='/login' size= 'small' variant= 'contained' color='white' style={{borderRadius:'30px',padding:'.51vw 4vw' ,marginRight:'2vh'}}>Get Started</Button>
                                <Button  variant= 'contained' size= 'small'  color='white' style={{borderRadius:'30px', color:'black',padding:'.51vw 3vw'}}> <Link  to="test1" spy={true} smooth={true} offset={50} duration={500}   >More about us</Link> </Button>
                            </Container>
                        </div>
                    </div>
                </div>
            </header>
            <Paper name="test1" style={{ padding:'15vh 0', width:'100vw'}}>
                <div className={classes.row}  >
                    <Container className={classes.column} >
                        <img src={Chat} alt='3' style={{paddingTop:'20vh'}} className={classes.Vectors}/>
                    </Container>
                    <div className={classes.column}>
                        <Container className= {classes.slideTextRight}>
                            <em className={classes.titleFontSize}>Safe and Exclusive, NEUMeet chat got that vibes!</em>
                            <p className={classes.DescriptionFontSize} >                            
                            Enjoy chatting with everyone, you can send emojis to make your conversations livelier and funnier or you can send files for realistic connection within your contacts.
                            </p>
                        </Container>
                    </div>
                </div>
            </Paper>
            <section className={classes.row} style={{background:'#636363 ', padding:'20vh 0 0 0 ', width:'100vw'}}>
                <div className={classes.column} >
                    <Container style={{color:'#fff'}} className= {classes.slideTextLeft}>
                        <em className={classes.titleFontSize}>
                            Academically competent! 
                        </em>
                        <p className={classes.DescriptionFontSize }>
                            Communication is the key for us to understand each other. 
                            With the help of this, users can freely use this platform for academic purposes
                            and easily be with everyone just in one click.
                        </p>
                    </Container>
                </div>
                <div className={classes.column}>
                    <img src={Users} alt='4' className={classes.Vectors}/>
                </div>
            </section>
            <Paper style={{ padding:'20vh 0', width:'100vw'}}>
                <div className={classes.row} >
                    <Container className={classes.column} >
                        <img src={Groups} alt='5' className={classes.Vectors}/>
                    
                    </Container>
                    <div className={classes.column}>
                        <Container style={{paddingTop:'10vh'}} className= {classes.slideTextRight}>
                            <em className={classes.titleFontSize}>Connect within your Peers</em>
                            <p className={classes.DescriptionFontSize } >                            
                            Create group for your favorite people and enjoy virtual teasing, playing, and gossiping. 
                            You can also add up people in a group and work on important matters for better productivity.
                            </p>
                        </Container>
                    </div>
                </div>
            </Paper>
            
            
            
            <section className={classes.row}  style={{background:'#636363',padding:'20vh 0', width:'100vw'}}>
                <div className={classes.column} >
                    <Container style={{color:'#fff'}}  className= {classes.slideTextLeft}>
                        <em className={classes.titleFontSize}>
                                
                            Make a stronger connection
                        </em>
                        <p className={classes.DescriptionFontSize }>
                            Regardless of your location, be endowed with video conferencing  where in you can connect within your peers and will also boost your productivity, teamwork , share information and experiences without the needs of being physically in one room.
                        </p>
                    </Container>
                </div>
                <div className={classes.column}>
                    <img src={VirtualVector} alt='6' className={classes.Vectors}/>
                </div>
            </section>
            
            <section className={classes.root} style={{background:'#fff', height:'60vh', }}>
                <Typography variant='h2' style={{letterSpacing:'.3vw',paddingBottom:'1vw',fontWeight: 600,paddingTop:'3vh',
                fontSize:'6vw'}}>Come and Join us</Typography>
                <Button href="/login" variant= 'contained' endIcon={<ArrowRightAltIcon sx={{ fontSize: 80 }}/>} color='primary' style={{borderRadius:'30px', marginTop:'5vw',padding:'1vw 4vw'}}>
                    Continue with NEUMeet
                </Button>
            </section>

            <footer className={classes.footer} style={{background:'#434543',  height:'50vh', }}>
                <section style={{margin:'5vw'}}>
                    <img src={NEUniteLogo} alt="logo" style ={{width:'4vw',margin:'0 .5vw 0 1vw'}} />
                    <Typography variant='h6' style={{color:'white',letterSpacing:'.3vw'}}>
                            <strong> <i>NEUMeet</i></strong>
                    </Typography>
                </section>
                <section style={{margin:'5vw'}}>
                    <Typography variant='h6'color>
                        Product
                    </Typography>
                    <Typography style={{color:'#fff'}}>
                    NEUMeet
                    </Typography>
                </section>
                
                <section style={{margin:'5vw'}}>
                    <Typography variant='h6'color>
                        Policies
                    </Typography>
                    <Typography style={{color:'#fff'}}>
                        Terms
                    </Typography>
                    <Typography style={{color:'#fff'}}>
                        Privacy
                    </Typography>
                    <Typography style={{color:'#fff'}}>
                        Guidlines
                    </Typography>
                    <Typography style={{color:'#fff'}}>
                        Licenses
                    </Typography>
                </section>
            </footer>
            
        </div>
    );
};

export default Home;
